
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"200","height":"200","rx":"10","fill":"#C7C7C7"}}),_c('path',{attrs:{"d":"M121.104 81.243l-5.347-13.116c-.714-1.418-1.783-2.127-3.209-2.127H85.452c-1.426 0-2.852.709-3.209 2.127l-5.347 13.116c-.713 1.418-2.14 2.127-3.566 2.127H61.565c-2.139 0-3.565 1.418-3.565 3.545v42.54c0 2.127 1.426 3.545 3.565 3.545h74.87c2.139 0 3.565-1.418 3.565-3.545v-42.54c0-2.127-1.426-3.545-3.565-3.545H124.67c-1.427 0-2.853-.709-3.566-2.127z","stroke":"#fff","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M99 122.365c10.83 0 19.609-8.729 19.609-19.498 0-10.768-8.779-19.497-19.609-19.497-10.83 0-19.609 8.73-19.609 19.497 0 10.769 8.78 19.498 19.61 19.498z","stroke":"#fff","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    